export default "__VITE_ASSET__CSKSUJqm__"